export default "__VITE_ASSET__B$D7sTx9__"